import { Space } from 'antd';
import { StyledTextWithAudio } from './TextWithAudio.styled';

export default function TextWithAudio({ className, text, playing }) {
  //console.log('[TextWithAudio]', text, playing);
  return (
    <StyledTextWithAudio className={className}>
      <span className={playing ? 'playing' : ''}>{text}</span>
      {playing && <span className="audio-playing" />}
    </StyledTextWithAudio>
  );
}
